<div class="add-edit-multi-matrix-block p-3">
  <div class="row">
    @if (actionType == 'Add') {
    <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
      <label>Select Service<b class="text-danger">*</b></label>
      <app-dropdown-with-search
        [Pixeltracking]="'false'"
        [showPlaceholder]="'false'"
        searchFlag="true"
        isMultiSelect="false"
        [dropdownData]="forecastServiceList"
        [selected]="selectedService"
        (selectionChange)="setSelectedServiceValue($event)"
      ></app-dropdown-with-search>
    </div>
    <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
      <label>Select Year<b class="text-danger">*</b></label>
      <app-dropdown-with-search
        [Pixeltracking]="'false'"
        [showPlaceholder]="'false'"
        searchFlag="true"
        isMultiSelect="false"
        [disableDD]="!selectedService?.Service"
        [dropdownData]="forecastYearList"
        [selected]="defaultYear"
        (selectionChange)="setSelectedYearValue($event)"
      ></app-dropdown-with-search>
    </div>
    } @if (actionType == 'Edit') {
    <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
      <label>Service</label>
      <p>{{ selectedData?.SRVDESC }} ({{ selectedData?.MULTI_SRV }})</p>
    </div>
    <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
      <label>Year</label>
      <p>{{ selectedData?.year }}</p>
    </div>
    }
  </div>
  <div class="row mt-3">
    @for (item of forecastMonthList; track item; let i = $index) {
    <div class="col-md-2 col-sm-2 col-lg-2 col-xl-2 col-xs-2 mt-2">
      <label>{{ item?.name }}<b class="text-danger">*</b></label>
      <mat-form-field appearance="outline">
        <input
          type="text"
          [(ngModel)]="forecastMonthList[i].currentValue"
          name="item{{ i }}"
          (input)="validateNumber($event, i)"
          matInput
        />
      </mat-form-field>
    </div>
    }
  </div>
  <div class="row mt-5">
    <div class="text-align-right">
      <button
        class="uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button"
        (click)="onSubmit()"
        [disabled]="!validateForm()"
      >
        {{ actionType == 'Add' ? 'Submit' : 'Update' }}
      </button>
    </div>
  </div>
  <!-- <div class="malti-matrix-management-fields">
  <div class="row">
    <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
      <label>Select Service</label>
      <app-dropdown-with-search [Pixeltracking]="'false'" [showPlaceholder]="'false'"
        searchFlag="true" isMultiSelect="false" [dropdownData]="forecastServiceList"
        [selected]="selectedService"
      (selectionChange)="setSelectedServiceValue($event)"></app-dropdown-with-search>
    </div>
    <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
      <label>Select Year</label>
      <app-dropdown-with-search [Pixeltracking]="'false'" [showPlaceholder]="'false'"
        searchFlag="true" isMultiSelect="false" [dropdownData]="forecastYearList"
        [selected]="selectedYear"
      (selectionChange)="setSelectedYearValue($event)"></app-dropdown-with-search>
    </div>
  </div>

  <div class="row">
    <button class="uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button"
    (click)="saveMultiMatrix()" (click)="onSubmit()" [disabled]="actionType == 'Add' ? isInValid : isChanged">{{actionType == 'Add' ? 'Submit' : 'Update'}}</button>
  </div>
</div> -->
</div>
<!-- <div class="stk-table-loader loader-position" *ngIf="showLoader">
<app-loader></app-loader>
</div> -->
